import React from 'react';

interface ContactDetailsProps {
	iconSrc: string;
	title: string;
	description: string;
        email:string;
companyName:string;
    CIN:string;
}

const ContactDetails: React.FC<ContactDetailsProps> = ({
	iconSrc,
	title,
	description,
        email,
companyName,
    CIN,
 
}) => {
	return (
		<div className="flex flex-col gap-1 sm:gap-4">
			{/* row 1 */}
			<div className="flex gap-1">
				<img src={iconSrc} alt="" />
				<h3 className="text-2xl font-extrabold leading-[30px] text-white min-w-[160px]">
					{title}
				</h3>
			</div>

			{/* row 2 */}
<p className="max-w-[330px] text-md leading-2 text-white">
                {companyName}
            </p>
{CIN?    <p className="max-w-[330px] text-md leading-2 text-white">
                CIN : {CIN}
            </p>:<></>}
			<p className="max-w-[330px] text-md leading-2 text-white">
				{description}
			</p>
                {email &&
                <div className="flex gap-3 ">
                <h3 className="text-md leading-2 text-white">
                    {email}
                </h3>
            </div>
            }
		</div>
	);
};

export default ContactDetails;
